import { applicationPddTestControllerCreateApplication } from './applicationPddTestControllerCreateApplication'
import { applicationPddTestControllerSetResult } from './applicationPddTestControllerSetResult'
import { applicationPddTestControllerStartTest } from './applicationPddTestControllerStartTest'

export const applicationPddTestService = { applicationPddTestControllerCreateApplication, applicationPddTestControllerStartTest, applicationPddTestControllerSetResult }